import { useState } from 'react';
import { generateResponse } from '../utils/chatUtils';

export function useChat() {
  const [isTyping, setIsTyping] = useState(false);

  const sendMessage = async (message: string): Promise<string> => {
    setIsTyping(true);
    
    // Add random delay for realism
    await new Promise(resolve => 
      setTimeout(resolve, 500 + Math.random() * 1500)
    );

    const response = generateResponse(message);
    setIsTyping(false);
    return response;
  };

  return {
    sendMessage,
    isTyping
  };
}